import {VisibilityProps} from "@/styles/visibility.types";
import {css} from "styled-components";
import theme from "@/styles/theme";

export const visibility = ({show, hide}: VisibilityProps) => {
    const hidden = {sm: false, md: false, lg: false, xl: false};
    if (hide?.length) {
        hide.forEach(h => {
            hidden[h] = true;
        });
    }
    if (show?.length) {
        hidden.sm = true;
        hidden.md = true;
        hidden.lg = true;
        hidden.xl = true;
        show.forEach(s => {
            hidden[s] = false;
        });
    }

    return css`
      ${hidden.sm && css`@media (max-width: ${theme.breakpoint.medium}px) {
        display: none !important
      }`}

      ${hidden.xl && css`@media (min-width: ${theme.breakpoint.xlarge}px) {
        display: none !important
      }`}
    `;
};
